// extracted by mini-css-extract-plugin
export default {"results":"results--OiEj","title":"title--Ncby","founded":"founded--W+ie","filters":"filters--Ara9"};